import {
    Component, OnInit,
    ViewEncapsulation
} from '@angular/core';
import { AccountSubscriptionsDetailsActionsPaymentMethod } from '../account.subscriptions.details.actions.payment-method';

@Component({
    selector: 'account-subscriptions-details-actions-payment-method-bank-slip',
    templateUrl: './account.subscriptions.details.actions.payment-method.bank-slip.component.html',
    styleUrls: ['./../../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsActionsPaymentMethodBankSlipComponent extends
    AccountSubscriptionsDetailsActionsPaymentMethod implements OnInit {

    ngOnInit() {
        this.choose(this.paymentMethod.id);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/account/subscriptions/details/actions/payment-method/bank-slip/account.subscriptions.details.actions.payment-method.bank-slip.component.ts